import React, { useContext, useEffect } from "react";
import "./App.css";
import Layout from "./components/Layout";
import Login from "./components/login/Login";
import "./index.css";
import { Routes, Route, HashRouter } from "react-router-dom";
import AppContext from "./AppContext";
import Settings from "./components/Settings";
import CustomerList from "./components/master/customer/CustomerList";
import { AssetType } from "./components/master/assetType/AssetType";
import { AssetForm } from "./components/master/assetType/AssetForm";
import AlarmSettings from "./components/master/alarm/AlarmSettings";
import ControllerForm from "./components/master/deviceType/ControllerForm";
import ControllerList from "./components/master/deviceType/ControllerList";
import AlarmList from "./components/master/alarm/AlarmList";
import UserList from "./components/master/user/UserList";
import UserForm from "./components/master/user/UserForm";
import CustomerForm from "./components/master/customer/CustomerForm";
import AssetTypePropertyList from "./components/dynamicMaster/asset/AssetTypePropertyList";
import AssetTypePropertyForm from "./components/dynamicMaster/asset/AssetTypePropertyForm";
import DevicePropertyList from "./components/dynamicMaster/device/DevicePropertyList";
import DevicePropertyForm from "./components/dynamicMaster/device/DevicePropertyForm";
import PasswordReset from "./components/login/PasswordReset";
import ChangePassword from "./components/login/ChangePassword";
import Home from "./components/home/Home";
import Authlayout from "./components/login/Authlayout";
import AssetDetails from "./components/assetDetails/AssetDetails";
import "react-toastify/dist/ReactToastify.css";
import ReportLists from "./components/analytics/ReportLists";
import IdleAnalytics from "./components/analytics/idle/IdleAnalytics";
import SpeedMetrics from "./components/analytics/speed/SpeedMetrics";
import { gapi } from "gapi-script";
import msalInstance, { Client_id } from "./constant";
import TravelAndFuelAnalytics from "./components/analytics/travel&fuel/TravelAndFuelAnalytics";
import CostAnalytics from "./components/analytics/cost/CostAnalytics";
import SafetyAnalytics from "./components/analytics/safety/SafetyAnalytics";
import AssetScheduler from "./components/master/AssetScheduler/AssetScheduler";
import AssetScheduleList from "./components/master/AssetScheduler/AssetScheduleList";
import CompanyList from "./components/master/Company/CompanyList";
import CompanyForm from "./components/master/Company/CompanyForm";
import FuelForm from "./components/master/fuelSettings/FuelForm";
import FuelList from "./components/master/fuelSettings/FuelList";
import HealthMonitoring from "./components/healthMonitoring/HealthMonitoring";
import TeamList from "./components/master/team/TeamList";
import TeamForm from "./components/master/team/TeamForm";
import Dashboard from "./components/dashboard/Dashboard";

function App() {
  const { authCtx } = useContext(AppContext);
  const isLoggedIn = authCtx.isLoggedIn;

  useEffect(() => {
    async function start() {
      try {
        await gapi.client.init({
          clientId: Client_id,
          scope: "",
        });
      } catch (error) {
        console.error("Error initializing Google client:", error);
      }
    }

    gapi.load("client:auth2", start);
    msalInstance.initialize();
  }, []);

  return (
    <>
      {isLoggedIn ? (
        <HashRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/home" element={<Home />} />

              {/* Route for parent asset */}
              <Route
                path="/details/parent/:assetId"
                element={<AssetDetails assetType="parent" />}
              />
              {/* Route for regular asset */}
              <Route
                path="/details/asset/:assetId"
                element={<AssetDetails assetType="asset" />}
              />{" "}
              <Route path="/settings" element={<Settings />} />
              <Route path="/customerlist" element={<CustomerList />} />
              <Route path="/customerform" element={<CustomerForm />} />
              <Route path="/assettype" element={<AssetType />} />
              <Route path="/assetform/:id" element={<AssetForm />} />
              <Route path="/controllerform/:id" element={<ControllerForm />} />
              <Route path="/assetScheduler/:id" element={<AssetScheduler />} />
              <Route
                path="/assetSchedulerList"
                element={<AssetScheduleList />}
              />
              <Route path="/controllerlist" element={<ControllerList />} />
              <Route path="/fuelform/:id" element={<FuelForm />} />
              <Route path="/fuellist" element={<FuelList />} />
              <Route path="/alarmSettings" element={<AlarmSettings />} />
              <Route path="/companyList" element={<CompanyList />} />
              <Route path="/companyForm/:id" element={<CompanyForm />} />
              <Route path="/teamList" element={<TeamList />} />
              <Route path="/teamForm/:id" element={<TeamForm />} />
              <Route path="/alarmSettings" element={<AlarmSettings />} />
              <Route path="/alarmList" element={<AlarmList />} />
              <Route path="/userlist" element={<UserList />} />
              <Route path="/analytics" element={<ReportLists />} />
              <Route
                path="/analytics/idleAnalytics"
                element={<IdleAnalytics />}
              />
              <Route path="/health" element={<HealthMonitoring />} />
              <Route
                path="/analytics/travelAndFuel"
                element={<TravelAndFuelAnalytics />}
              />
              <Route
                path="/analytics/costAnalytics"
                element={<CostAnalytics />}
              />
              <Route
                path="/analytics/safetyAnalytics"
                element={<SafetyAnalytics />}
              />
              <Route
                path="/analytics/speedMetrics"
                element={<SpeedMetrics />}
              />
              {/* <Route path="/roadmap" element={<CommingSoon />} /> */}
              <Route path="/userform/:id" element={<UserForm />} />
              <Route
                path="/assettypepropertylist/:header/:id"
                element={<AssetTypePropertyList />}
              />
              <Route
                path="/assettypepropertyform/:header/:id/:selectedId"
                element={<AssetTypePropertyForm />}
              />
              <Route
                path="/devicepropertylist/:header/:id"
                element={<DevicePropertyList />}
              />
              <Route
                path="/devicepropertyform/:header/:id/:selectedId"
                element={<DevicePropertyForm />}
              />
            </Routes>
          </Layout>
        </HashRouter>
      ) : (
        <HashRouter>
          <Authlayout>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="resetPassword" element={<PasswordReset />} />
              <Route
                path="changePassword/:token"
                element={<ChangePassword />}
              />
            </Routes>
          </Authlayout>
        </HashRouter>
      )}
    </>
  );
}

export default App;
